module.exports = __webpack_public_path__ + "static/media/clima.523d87e7.jpg";